import React from 'react'
import {connect} from 'react-redux'
import styles from './auth.scss'
import reactStringReplace from 'react-string-replace'
import {changePassword} from 'state/actions'
import {hasErrors} from 'state/actions/api'
import cs from 'classnames'

import i18n from 'lib/i18n'
const _ = i18n('passwordChange')

@connect(state => ({
	password: state.auth.password,
	errors: state.auth.errors,
}))
export default class PasswordReset extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		errors: React.PropTypes.object,
		password: React.PropTypes.string,
	}
	changePassword(ev) {
		ev.preventDefault()
		const {dispatch, password} = this.props
		const oldPassword = password || this.refs.oldPassword.value
		const newPassword = this.refs.newPassword.value
		const confirmNewPassword = this.refs.confirmNewPassword.value
		const confirmPrivacyPolicy = this.refs.confirmPrivacyPolicy.checked
		const regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[_\-$%.!:<>*#%])[a-zA-Z0-9_\-$.!:<>*#%]{10,}$/

		
		if (!oldPassword) {
			// Note: next time, just use redux-form validation
			dispatch(hasErrors('oldPasswordWrong'))
			return
		}

		if (oldPassword === newPassword) {
			dispatch(hasErrors('cantUseTheSamePassword'))
			return
		}

		if (newPassword !== confirmNewPassword) {
			dispatch(hasErrors('checkConfirmPassword'))
			return
		}

		if (!regex.test(newPassword)) {
			dispatch(hasErrors('passwordRules'))
			return
		}

		if(!confirmPrivacyPolicy) {
			dispatch(hasErrors('checkConfirmPrivacyPolicy'))
			return
		}

		dispatch(changePassword(oldPassword, newPassword))
	}
	render() {
		const {errors, password} = this.props
		const regEx = /(https?:\/\/\S+)/g
		const replacementFunction = (match, i, ofset) => <a href={match} key={match + i}>{match}</a>
		const checkboxDescription = reactStringReplace(_('privacyStatementCheckbox'), regEx, replacementFunction)
		return (
			<div className={styles.changePaswordFormsContainer}>
				<div className={styles.loginForm}>
					<div className={cs(styles.formImage, styles.passwordChangeImage)}>
						<img src={require("resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg")}/>
					</div>
					<form onSubmit={(ev) => this.changePassword(ev)} method="post" className={styles.form}>
						<div className={cs(styles.formGroup, styles.formPaswordChangeGroup)}>
							{!password &&
								<label>
									{_('oldPassword')}
									<input ref="oldPassword" type="password" name="oldPassword"/>
								</label>
							}
						</div>
						<div className={cs(styles.info, styles.formPaswordChangeGroup)}>
							{_('passwordRules')}
						</div>
						<div className={cs(styles.formGroup, styles.formPaswordChangeGroup)}>
							<label>
								{_('newPassword')}
								<input ref="newPassword" type="password" name="newPassword"/>
							</label>
						</div>
						<div className={cs(styles.formGroup, styles.formPaswordChangeGroup)}>
							<label>
								{_('confirmNewPassword')}
								<input ref="confirmNewPassword" type="password" name="confirmNewPassword"/>
							</label>
						</div>
						<div className={cs(styles.info, styles.paswordChangeInfo)}>
							<span className={cs(styles.privacyCheckboxLabel)}>
								<input ref="confirmPrivacyPolicy" type="checkbox" name="confirmPrivacyPolicy"/>
								<span>{checkboxDescription}</span>
							</span>
						</div>
						<div className={cs(styles.errorMessage, styles.formPaswordChangeGroup)}>
							{errors && _(errors.id)}
						</div>
						<div className={styles.formGroup}>
							<button className={cs(styles.submitButton, styles.formPaswordChangeGroup)}>{_('changePassword')}</button>
						</div>
					</form>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/auth/passwordChange.jsx